import { Box, Container, Stack, Typography, Chip } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import HomeIcon from "@mui/icons-material/Home";
import SectionHeader from "../components/SectionHeader";

interface TrustedByStripProps {
  bgcolor?: string;
  title?: string;
  subtitle?: string;
  items?: Array<{ icon: React.ReactElement; label: string }>;
}

const defaultItems = [
  {
    icon: <BusinessIcon aria-hidden="true" />,
    label: "Multi-unit short-term rental operators",
  },
  {
    icon: <VpnKeyIcon aria-hidden="true" />,
    label: "Boutique property management companies",
  },
  {
    icon: <HomeIcon aria-hidden="true" />,
    label: "Independent Airbnb & VRBO hosts",
  },
];

export default function TrustedByStrip({
  bgcolor = "background.default",
  title = "Trusted by Short-Term Rental Hosts in Toronto",
  subtitle = "We work with independent hosts and professional operators.",
  items = defaultItems,
}: TrustedByStripProps) {
  return (
    <Box
      component="section"
      sx={{
        bgcolor,
        py: { xs: 6, md: 8 },
        borderTop: 1,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Stack
          spacing={4}
          alignItems="center"
          sx={{
            textAlign: "center",
          }}
        >
          {/* Title */}
          <Box sx={{ textAlign: "center" }}>
            <SectionHeader title={title} subtitle={subtitle} />
          </Box>

          {/* Items */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 2, md: 3 }}
            sx={{
              width: "100%",
              justifyContent: "center",
              alignItems: { xs: "stretch", sm: "center" },
              flexWrap: "wrap",
            }}
          >
            {items.map((item, index) => (
              <Chip
                key={index}
                icon={item.icon}
                label={item.label}
                sx={{
                  bgcolor: "background.default",
                  border: 1,
                  borderColor: "divider",
                  borderRadius: "24px",
                  py: 2.5,
                  px: 1.5,
                  height: "auto",
                  fontSize: { xs: "0.875rem", md: "0.9375rem" },
                  fontWeight: 500,
                  "& .MuiChip-label": {
                    px: 2,
                    py: 0.5,
                    whiteSpace: "normal",
                    textAlign: "center",
                  },
                  "& .MuiChip-icon": {
                    fontSize: "1.25rem",
                    color: "primary.main",
                    ml: 1,
                  },
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    bgcolor: "rgba(0, 0, 0, 0.04)",
                    transform: "translateY(-2px)",
                  },
                  minWidth: { xs: "100%", sm: "220px", md: "260px" },
                  maxWidth: { xs: "100%", sm: "300px" },
                }}
              />
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
